// Config file to manage App Configuration Variables

// Max Recipient Count per Transfer
// NOTE: This value is also contained in the Teller Application
export const MAX_RECIPIENT_COUNT = 20;
export const VALUE_LOAD_FILE_UPLOAD_LENGTH_LIMIT = 10000;